import styled, { css } from 'styled-components/macro'

export const CounterWrapper = styled.div`
  display: inline-flex;
`

export const DigitsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 1em;
  overflow: hidden;
  margin-right: -0.07em;
`

export const DigitEl = styled.span<{ animated: boolean }>`
  line-height: 1;
  text-align: center;

  ${props =>
    props.animated &&
    css`
      transition: transform 0.3s;
    `}
`
